<template>
  <nav class="navbar" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <a class="navbar-item">
        <h4 class="title is-4">Connections<br>Ministry</h4>
      </a>

      <button :class="{'button': true, 'navbar-burger': true, 'is-active': menu_mobile_flag}" @click="activateMobileMenu">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
    <div class="navbar-menu" :class="{'navbar-menu': true, 'is-active': menu_mobile_flag}">
      <div class="navbar-start">
        <menu-item v-for="(menu_row, index) in menu_list" :key="index" :menu-row="menu_row" :data-index="index" @open-dropdown="openDropdown"></menu-item>
      </div>
      <div class="navbar-end">
        <span class="navbar-item non-select" v-text="'Welcome, ' + name"></span>
        <router-link class="navbar-item non-select" to="/panel/logout">Logout</router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import MenuItem from './MenuItem'
export default {
  data () {
    return {
      name: '',
      menu_list: [],
      menu_mobile_flag: false
    }
  },
  created () {
    this.menu_list = [
      {
        title: 'Profile',
        label: 'profile',
        path: '/panel/profile',
        type: 0,
        dropdown_active: false,
        show: 0
      },
      {
        title: 'Lost and Found',
        label: 'lost_found',
        path: '/panel/lost_found',
        type: 0,
        dropdown_active: false,
        show: 1
      },
      {
        title: 'Admin',
        label: '',
        path: '',
        show: 0,
        dropdown_active: false,
        type: 1,
        sub: [
          {
            title: 'Menu',
            label: 'menu_list',
            path: '/panel/menu',
            show: 0
          },
          {
            title: 'Role',
            label: 'role',
            path: '/panel/role',
            show: 0
          },
          {
            title: 'Member',
            label: 'member',
            path: '/panel/member',
            show: 0
          },
          {
            title: 'Member Role',
            label: 'member_role',
            path: '/panel/member/role',
            show: 0
          },
          {
            title: 'Event',
            label: 'event',
            path: '/panel/event',
            show: 0
          },
          {
            title: 'Assign Trainee',
            label: 'assign_trainee',
            path: '/panel/trainee',
            show: 0
          }
        ]
      },
      {
        title: 'Team',
        label: '',
        path: '',
        show: 0,
        dropdown_active: false,
        type: 1,
        sub: [
          {
            title: 'Team Member Division',
            label: 'team_member_div',
            path: '/panel/division',
            show: 0
          },
          {
            title: 'Team Member HD',
            label: 'team_member_hd',
            path: '/panel/team_member/hd',
            show: 0
          },
          {
            title: 'Team Member CC',
            label: 'team_member_cc',
            path: '/panel/team_member/cc',
            show: 0
          },
          {
            title: 'Team Member TL',
            label: 'team_member_tl',
            path: '/panel/team_member/tl',
            show: 0
          },
          {
            title: 'Team Member TM',
            label: 'team_member_tm',
            path: '/panel/team_member/tm',
            show: 0
          },
          {
            title: 'Service Task',
            label: 'task',
            path: '/panel/task',
            show: 0
          },
          {
            title: 'Task Attendance',
            label: 'task_attendance',
            path: '/panel/task/attendance',
            show: 0
          },
          {
            title: 'Close Task',
            label: 'task_finish',
            path: '/panel/task_finish',
            show: 0
          }
        ]
      },
      {
        title: 'Floor Area',
        label: '',
        path: '',
        type: 1,
        dropdown_active: false,
        show: 0,
        sub: [
          {
            title: 'Seat Management',
            label: 'seat_management',
            path: '/panel/floorarea/seat_management',
            show: 0
          },
          {
            title: 'Seat Info',
            label: 'seat_info',
            path: '/panel/floorarea/seat_info',
            show: 0
          }
        ]
      },
      {
        title: 'Frontdesk',
        label: '',
        path: '',
        type: 1,
        dropdown_active: false,
        show: 0,
        sub: [
          {
            title: 'My Counter',
            label: 'frontdesk',
            path: '/panel/frontdesk',
            show: 0
          },
          {
            title: 'My Transactions',
            label: 'my_transactions',
            path: '/panel/frontdesk/my_transactions',
            show: 0
          },
          {
            title: 'All Transactions',
            label: 'transactions',
            path: '/panel/frontdesk/transactions',
            show: 0
          },
          {
            title: 'Report Giving Counter',
            label: 'report_giving_counter',
            path: '/panel/frontdesk/report_counter',
            show: 0
          },
          {
            title: 'Report Giving TL',
            label: 'report_giving',
            path: '/panel/frontdesk/report',
            show: 0
          },
          {
            title: 'Report Giving CC',
            label: 'report_giving_cc',
            path: '/panel/frontdesk/report_cc',
            show: 0
          },
          {
            title: 'Report Giving HD',
            label: 'report_giving_hd',
            path: '/panel/frontdesk/report_hd',
            show: 0
          },
          {
            title: 'Report Event Counter',
            label: 'report_event_counter',
            path: '/panel/frontdesk/report_event_counter',
            show: 0
          },
          {
            title: 'Report Event TL',
            label: 'report_event',
            path: '/panel/frontdesk/report_event',
            show: 0
          },
          {
            title: 'Report Event CC',
            label: 'report_event_cc',
            path: '/panel/frontdesk/report_event_cc',
            show: 0
          },
          {
            title: 'Report Event HD',
            label: 'report_event_hd',
            path: '/panel/frontdesk/report_event_hd',
            show: 0
          },
          {
            title: 'Summary Service',
            label: 'summary_service',
            path: '/panel/frontdesk/summary/service',
            show: 0
          },
          {
            title: 'Close Counter',
            label: 'close_counter',
            path: '/panel/frontdesk/close_counter',
            show: 0
          }
        ]
      }
    ]

    this.checkMenuRole()
  },
  components: {
    MenuItem
  },
  watch: {
    '$route' (to, from) {
      this.menu_mobile_flag = false
    }
  },
  methods: {
    checkMenuRole () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('menu/check_menu', {
        menu_list: self.menu_list
      }).then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.menu_list = response.data.data.menu_list
          self.name = response.data.data.name
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    activateMobileMenu () {
      if (this.menu_mobile_flag === false) {
        this.menu_mobile_flag = true
      } else {
        this.menu_mobile_flag = false
      }
    },
    openDropdown (value) {
      if (this.menu_list[value].dropdown_active === true) {
        this.menu_list[value].dropdown_active = false
      } else {
        for (var index in this.menu_list) {
          this.menu_list[index].dropdown_active = false
        }
        this.menu_list[value].dropdown_active = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .non-select {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/panel/components/Headermenu.vue